module.exports = __webpack_public_path__ + "img/booming.73e3f118.svg";